import { jsx } from "react/jsx-runtime";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { validateTidalLicense } from "../../base/index.js";
function SaveAlt(props) {
  return /* @__PURE__ */ jsx(
    SaveAltIcon,
    {
      "data-testid": "SaveAlt",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "SaveAlt",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
SaveAlt.tidalIconMeta = {
  categories: "fileActions",
  name: "SaveAlt"
};
validateTidalLicense();
export {
  SaveAlt
};
//# sourceMappingURL=SaveAlt.js.map
